import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  ComponentHeader,
  ComponentBread,
  StyledInnerListPage,
  StyledOuterListPage,
  SharedButton,
  DownloadV2,
} from "@components";

import { PATH_COUPON_FAMILY, PATH_COUPON_LIST, couponFamilyFilter } from "@configs";
import { IAdvanceSearch } from "@interfaces";
import { CouponFamilyTable } from "@modules";
import { selectApp } from "@redux";
import {
  getApiErrorMessage,
  useCouponFamilyCouponsPage,
  useExportActiveCoupons,
  useNotify,
} from "@utils";
import { Tooltip } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { AdvanceFilter } from "@modules";

export const PageCouponFamily = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { success, error } = useNotify();
  const exportActiveCoupons = useExportActiveCoupons();
  const [isAdvance, setIsAdvance] = useState<boolean>(false);
  useSelector(selectApp);

  const {
    data,
    total,
    page,
    filters,
    text,
    date,
    refetch,
    setAdvance,
    handleDateFilter,
    handlePagination,
    changeFilter,
    searchText,
    handleClearSearch,
    handleClearDate,
  } = useCouponFamilyCouponsPage(id);

  const steps = [
    {
      title: <a href={PATH_COUPON_LIST}>{t("page.coupon_management")}</a>,
    },
    {
      title: <a href={PATH_COUPON_FAMILY}>{t("page.selected_program_name")}</a>,
    },
  ];

  const handleAdvance = () => setIsAdvance(!isAdvance);
  const handleAdvanceFilter = (params: IAdvanceSearch) => {
    setAdvance(params);
    handleAdvance();
  };

  const handleDownloadCsv = async () => {
    try {
      const { data: fileData } = await exportActiveCoupons.mutateAsync({
        id,
        params: {
          searchColumn: filters,
          search: text,
          startDate: date[0],
          endDate: date[1],
        },
      });
      const url = window.URL.createObjectURL(new Blob([fileData], { type: "text/csv" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export redeem coupon");
      link.click();
      window.URL.revokeObjectURL(url);
      success(t("message.download.success"));
    } catch (err) {
      error(getApiErrorMessage(err, t("message.download.fail")));
    }
  };

  const downloadButton = (
    <Tooltip title={t("page.download_active_coupon_excel")}>
      <SharedButton
        type="primary"
        icon={<DownloadV2 />}
        size="middle"
        onClick={handleDownloadCsv}
        style={{ background: "#00AA67", color: "#fff" }}
      >
        {t("page.download_coupons")}
      </SharedButton>
    </Tooltip>
  );

  const button = (
    <Tooltip title={t("page.add_advance_filter")}>
      <SharedButton type="primary" size="middle" onClick={handleAdvance}>
        {t("page.advance_filter")}
      </SharedButton>
    </Tooltip>
  );

  return (
    <>
      <ComponentHeader title={t("page.coupon_management")} />
      <StyledOuterListPage>
        <ComponentBread pages={steps} />
        <StyledInnerListPage>
          <SearchFilter
            filter={couponFamilyFilter}
            actionBtn={downloadButton}
            callbackFun={changeFilter}
            onDateChange={handleDateFilter}
            searchText={searchText}
            searchInputPlaceholder={t("page.search_user_by")}
            selectedOption={filters}
            advanceBtn={button}
          />
          <SelectedFilter
            handleClearSearch={handleClearSearch}
            selected={filters}
            formDate={date[0]}
            toDate={date[1]}
          />
          <CouponFamilyTable data={data} callback={refetch} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
        <AdvanceFilter visible={isAdvance} callback={handleAdvanceFilter} />
      </StyledOuterListPage>
    </>
  );
};
